import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import { ExpertRequestStage } from '@/__generated__/graphql';
import EditMembersForm from '@/components/EditProjectMembers/Form';
import FAIcon from '@/components/Icon/FAIcon';
import MediaQuery from '@/components/MediaQuery';
import { sortMembers } from '@/core/project';
import { black } from '@/theme/colors';
import { SCREEN_XS } from '@/theme/screens';

import s from './AddMembers.module.scss';

const iconStyle = {
  width: 16,
  height: 16,
  fontSize: 16,
  margin: 16 * 0.2,
  color: black,
};

// Header/subheader by ER lifecycle stage (ENG-5313). A draft hasn't been submitted
// for sourcing yet, so its copy avoids promising active matching.
export const ADD_MEMBERS_COPY = {
  active: {
    header: 'We’re working on finding your Expert matches.',
    subHeader: 'In the meantime, invite your team members to your project.',
  },
  draft: {
    header: 'Your draft is saved.',
    subHeader: 'Invite your team members to your project.',
  },
} as const;

function AddMembers({ viewer, project, expertRequestId, stage }: any) {
  const navigate = useNavigate();
  const projectMembers = project.members || [];
  const membersToEdit = sortMembers(
    projectMembers.filter((m: any) => m.role !== 'expert' && m.state === 'active')
  );
  const copy =
    stage === ExpertRequestStage.Draft ? ADD_MEMBERS_COPY.draft : ADD_MEMBERS_COPY.active;

  return (
    <div>
      <div className={s.header}>
        <div className={s.headerIcon}>
          <FAIcon icon="binoculars" style={iconStyle} />
        </div>
      </div>
      <div className={s.header}>{copy.header}</div>
      <div className={s.subHeader}>{copy.subHeader}</div>
      <MediaQuery maxWidth={SCREEN_XS}>
        {(isMobileVersion: any) => (
          <EditMembersForm
            project={project}
            initialValues={{ members: membersToEdit }}
            onReset={() => navigate(`/expert_request/${expertRequestId}`)}
            onSubmit={() => navigate(`/expert_request/${expertRequestId}`)}
            usersLocked={[viewer.id]}
            buttonSize={isMobileVersion ? 'small' : 'medium'}
          />
        )}
      </MediaQuery>
    </div>
  );
}

const Component = connect((state) => ({
  // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
  viewer: state.viewer,
}))(AddMembers);
export default Component;
